import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Slider from "react-slick";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import GalleryPageIamge from "../assets/img/GalleryPageIamge.jpg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { motion } from "framer-motion";
import Fancybox2 from "../components/Fancybox2";
import barbieCakeZeppoli from "../assets/img/coverImageGallery/barbieCakeZeppoli.jpg";
import makeupCakeZeppoli from "../assets/img/coverImageGallery/makeupCakeZeppoli.jpg";
import babyShowerCakeZeppoli from "../assets/img/coverImageGallery/babyshowerCakeZeppoli.jpg";
import cartoonCakeZeppoli from "../assets/img/coverImageGallery/cartoonCakeZeppoli.jpg";
import lettersCakeZeppoli from "../assets/img/coverImageGallery/lettersCakeZeppoli.jpg";
import engagementCakeZeppoliOne from "../assets/img/cakeImagesGallery/engagement/engagementCakeZeppoliOne.png";
import engagementCakeZeppoliTwo from "../assets/img/cakeImagesGallery/engagement/engagementCakeZeppoliTwo.png";
import engagementCakeZeppoliThree from "../assets/img/cakeImagesGallery/engagement/engagementCakeZeppoliThree.png";
import engagementCakeZeppoliFour from "../assets/img/cakeImagesGallery/engagement/engagementCakeZeppoliFour.png";
import engagementCakeZeppoliFive from "../assets/img/cakeImagesGallery/engagement/engagementCakeZeppoliFive.png";
import engagementCakeZeppoliSix from "../assets/img/cakeImagesGallery/engagement/engagementCakeZeppoliSix.png";
import engagementCakeZeppoliSeven from "../assets/img/cakeImagesGallery/engagement/engagementCakeZeppoliSeven.png";
import engagementCakeZeppoliEight from "../assets/img/cakeImagesGallery/engagement/engagementCakeZeppoliEight.png";
import engagementCakeZeppoliNine from "../assets/img/cakeImagesGallery/engagement/engagementCakeZeppoliNine.png";
import engagementCakeZeppoliTen from "../assets/img/cakeImagesGallery/engagement/engagementCakeZeppoliTen.png";
import engagementCakeZeppoliEleven from "../assets/img/cakeImagesGallery/engagement/engagementCakeZeppoliEleven.png";
import engagementCakeZeppoliTwelve from "../assets/img/cakeImagesGallery/engagement/engagementCakeZeppoliTwelve.png";
import engagementCakeZeppoliThirteen from "../assets/img/cakeImagesGallery/engagement/engagementCakeZeppoliThirteen.png";
import engagementCakeZeppoliFourteen from "../assets/img/cakeImagesGallery/engagement/engagementCakeZeppoliFourteen.png";
import engagementCakeZeppoliFifteen from "../assets/img/cakeImagesGallery/engagement/engagementCakeZeppoliFifteen.png";
import engagementCakeZeppoliSixteen from "../assets/img/cakeImagesGallery/engagement/engagementCakeZeppoliSixteen.png";
import engagementCakeZeppoliSeventeen from "../assets/img/cakeImagesGallery/engagement/engagementCakeZeppoliSeventeen.png";
import engagementCakeZeppoliEighteen from "../assets/img/cakeImagesGallery/engagement/engagementCakeZeppoliEighteen.png";
import engagementCakeZeppoliNinteen from "../assets/img/cakeImagesGallery/engagement/engagementCakeZeppoliNinteen.png";
import engagementCakeZeppoliTwenty from "../assets/img/cakeImagesGallery/engagement/engagementCakeZeppoliTwenty.png";

function EngagementCakeGallery() {
  useEffect(() => {
    document.title = "Zeppoli Bakers | Gallery | Engagement Cake";
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  const directorsSliderSettings = {
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    cssEase: "linear",
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  // for fancy box
  const opts = {
    fullScreen: {
      autoStart: true, // Auto-start in full-screen mode
    },
    Thumbs: false,
  };

  // for gallery filters
  const allCards = [
    {
      category: "Cake",
      image: engagementCakeZeppoliOne,
      id: 1,
    },
    {
      category: "Cake",
      image: engagementCakeZeppoliTwo,
      id: 2,
    },
    {
      category: "Cake",
      image: engagementCakeZeppoliThree,
      id: 3,
    },
    {
      category: "Cake",
      image: engagementCakeZeppoliFour,
      id: 4,
    },
    {
      category: "Cake",
      image: engagementCakeZeppoliFive,
      id: 5,
    },
    {
      category: "Cake",
      image: engagementCakeZeppoliSix,
      id: 6,
    },
    {
      category: "Cake",
      image: engagementCakeZeppoliSeven,
      id: 7,
    },
    {
      category: "Cake",
      image: engagementCakeZeppoliEight,
      id: 8,
    },
    {
      category: "Cake",
      image: engagementCakeZeppoliNine,
      id: 9,
    },
    {
      category: "Cake",
      image: engagementCakeZeppoliTen,
      id: 10,
    },
    {
      category: "Cake",
      image: engagementCakeZeppoliEleven,
      id: 11,
    },
    {
      category: "Cake",
      image: engagementCakeZeppoliTwelve,
      id: 12,
    },
    {
      category: "Cake",
      image: engagementCakeZeppoliThirteen,
      id: 13,
    },
    {
      category: "Cake",
      image: engagementCakeZeppoliFourteen,
      id: 14,
    },
    {
      category: "Cake",
      image: engagementCakeZeppoliFifteen,
      id: 15,
    },
    {
      category: "Cake",
      image: engagementCakeZeppoliSixteen,
      id: 16,
    },
    {
      category: "Cake",
      image: engagementCakeZeppoliSeventeen,
      id: 17,
    },
    {
      category: "Cake",
      image: engagementCakeZeppoliEighteen,
      id: 18,
    },
    {
      category: "Cake",
      image: engagementCakeZeppoliNinteen,
      id: 19,
    },
    {
      category: "Cake",
      image: engagementCakeZeppoliTwenty,
      id: 20,
    },
  ];

  // for animation begin
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    // Cleanup timeout if the component unmounts
    return () => clearTimeout(timer);
  }, []);
  // upside animation
  const variants5 = {
    hidden: { opacity: 0, y: 100 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        type: "spring",
        stiffness: 50,
        damping: 20,
      },
    }),
  };
  // for animation end

  return (
    <>
      <Navbar />

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={variants5}
      >
        <div className="breadcumb-wrapper " data-bg-src={GalleryPageIamge}>
          <div
            className="container z-index-common"
            style={{ marginTop: "150px" }}
          >
            <div className="breadcumb-content">
              <h1 className="breadcumb-title text-white">Gallery</h1>
              <ul className="breadcumb-menu">
                <li>
                  <Link className="text-white" to="/">
                    Home
                  </Link>
                </li>
                <li className="text-white">Gallery</li>
                <li className="text-white">Engagement Cake</li>
              </ul>
            </div>
          </div>
        </div>
      </motion.div>

      <section className="space">
        <div className="container">
          {isVisible && (
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={variants5}
            >
              <div className="title-area text-center">
                <span className="sub-title">Cake Gallery</span>
                <h2 className="sec-title">Our Latest Engagement Cake</h2>
              </div>
            </motion.div>
          )}

          <div className="row gy-40 filter-active">
            {allCards.map((card) => (
              <div
                className={`col-xl-3 col-lg-4 col-sm-6 filter-item`}
                key={card.id}
              >
                {isVisible && (
                  <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={variants5}
                  >
                    <div className="th-product product_style1">
                      <div
                        style={{
                          borderRadius: "12px",
                          height: "365px",
                        }}
                        className="mx-15"
                      >
                        <LazyLoadImage
                          alt="Zeppoli enagement cake image"
                          effect="blur"
                          wrapperProps={{
                            style: { transitionDelay: "1s" },
                          }}
                          src={card.image}
                          placeholderSrc={card.image}
                          style={{
                            borderRadius: "12px",
                            width: "270px",
                          }}
                        />
                      </div>
                    </div>
                  </motion.div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {isVisible && (
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={variants5}
        >
          <div className="title-area text-center">
            <h2 className="sec-title">Explore More Categories</h2>
          </div>

          <div className="container">
            <div className="px-lg-4 px-3 my-5">
              <Fancybox2 options={opts}>
                <Slider
                  {...directorsSliderSettings}
                >
                  <div>
                    <div className="gallery-card mx-2">
                      <div
                        className="gallery-img"
                        style={{ borderRadius: "12px" }}
                      >
                        <LazyLoadImage
                          alt="Gallery One Zeppoli"
                          effect="blur"
                          wrapperProps={{
                            style: { transitionDelay: "1s" },
                          }}
                          src={barbieCakeZeppoli}
                          placeholderSrc={barbieCakeZeppoli}
                          width={"310px"}
                          style={{ borderRadius: "12px" }}
                        />
                      </div>
                      <div
                        className="gallery-content"
                        style={{ borderRadius: "12px" }}
                      >
                        <Link
                          to="/barbiecakegallery"
                          className="icon-btn popup-img"
                        >
                          <i className="fas fa-eye"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="gallery-card mx-2">
                      <div
                        className="gallery-img"
                        style={{ borderRadius: "12px" }}
                      >
                        <LazyLoadImage
                          alt="Gallery Two Zeppoli"
                          effect="blur"
                          wrapperProps={{
                            style: { transitionDelay: "1s" },
                          }}
                          src={makeupCakeZeppoli}
                          placeholderSrc={makeupCakeZeppoli}
                          width={"310px"}
                          style={{ borderRadius: "12px" }}
                        />
                      </div>
                      <div
                        className="gallery-content"
                        style={{ borderRadius: "12px" }}
                      >
                        <Link
                          to="/makeupcakegallery"
                          className="icon-btn popup-img"
                        >
                          <i className="fas fa-eye"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="gallery-card mx-2">
                      <div
                        className="gallery-img"
                        style={{ borderRadius: "12px" }}
                      >
                        <LazyLoadImage
                          alt="Gallery Three Zeppoli"
                          effect="blur"
                          wrapperProps={{
                            style: { transitionDelay: "1s" },
                          }}
                          src={babyShowerCakeZeppoli}
                          placeholderSrc={babyShowerCakeZeppoli}
                          width={"310px"}
                          style={{ borderRadius: "12px" }}
                        />
                      </div>
                      <div
                        className="gallery-content"
                        style={{ borderRadius: "12px" }}
                      >
                        <Link
                          to="/babyshowercakegallery"
                          className="icon-btn popup-img"
                        >
                          <i className="fas fa-eye"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="gallery-card mx-2">
                      <div
                        className="gallery-img"
                        style={{ borderRadius: "12px" }}
                      >
                        <LazyLoadImage
                          alt="Gallery Four Zeppoli"
                          effect="blur"
                          wrapperProps={{
                            style: { transitionDelay: "1s" },
                          }}
                          src={cartoonCakeZeppoli}
                          placeholderSrc={cartoonCakeZeppoli}
                          width={"310px"}
                          style={{ borderRadius: "12px" }}
                        />
                      </div>
                      <div
                        className="gallery-content"
                        style={{ borderRadius: "12px" }}
                      >
                        <Link
                          to="/cartooncakegallery"
                          className="icon-btn popup-img"
                        >
                          <i className="fas fa-eye"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="gallery-card mx-2">
                      <div
                        className="gallery-img"
                        style={{ borderRadius: "12px" }}
                      >
                        <LazyLoadImage
                          alt="Gallery Five Zeppoli"
                          effect="blur"
                          wrapperProps={{
                            style: { transitionDelay: "1s" },
                          }}
                          src={lettersCakeZeppoli}
                          placeholderSrc={lettersCakeZeppoli}
                          width={"310px"}
                          style={{ borderRadius: "12px" }}
                        />
                      </div>
                      <div
                        className="gallery-content"
                        style={{ borderRadius: "12px" }}
                      >
                        <Link
                          to="/letterscakegallery"
                          className="icon-btn popup-img"
                        >
                          <i className="fas fa-eye"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </Slider>
              </Fancybox2>
            </div>
          </div>
        </motion.div>
      )}

      <Footer />
    </>
  );
}

export default EngagementCakeGallery;
